module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticClass: "first-slide",
    attrs: {
      "src": _vm.contentList[0].thumbnail,
      "alt": "First slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[0].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[0].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[0]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "second-slide",
    attrs: {
      "src": _vm.contentList[1].thumbnail,
      "alt": "Second slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[1].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[1].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[1]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "third-slide",
    attrs: {
      "src": _vm.contentList[2].thumbnail,
      "alt": "Third slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[2].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[2].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[2]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "container marketing"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[0].name) + '%7C' + _vm.placesList[0].latitude + ',' + _vm.placesList[0].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[0].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[0].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[0]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4  col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[1].name) + '%7C' + _vm.placesList[1].latitude + ',' + _vm.placesList[1].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[1].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[1].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[1]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4  col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[2].name) + '%7C' + _vm.placesList[2].latitude + ',' + _vm.placesList[2].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[2].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[2].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[2]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[0].title) + " "), _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[0].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[0].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7 col-md-push-5"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[1].title) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("See for yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[1].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[1].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[2].title) + " "), _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[2].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[2].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": _vm.contentList[0].thumbnail,
      "alt": "First slide"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": "https://blog.openshift.com/wp-content/uploads/DevOps-Covey-768x576.png",
      "alt": "First slide"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-md-pull-7"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": "https://kubernetes.io/images/favicon.png",
      "alt": "First slide"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abc1baae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 448
// module chunks = 1